// extracted by mini-css-extract-plugin
export default {"wrapper":"VideoSide_wrapper__b8h5y","img":"VideoSide_img__xdAxM"};